<button mat-icon-button [disabled]="zoningCode.isDeleting" [class.not-clickable-actions-buttons]="zoningCode.isDeleting"
    class="actions-buttons">
    <mat-icon matTooltip="Check status" (click)="checkZCStatus($event, zoningCode)" class="actions-mat-icons">info
    </mat-icon>
</button>